import { CommonTrainInfoFormProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoForm";
import {
  BatchSubTypeProps,
  CommonSubTypeProps,
} from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoFormModal";
import { FC } from "react";

type GroupedTrainContext = {
  trainFormPrefix: `\${groupKey}.${number}.trainForm`;
};

type SingleTrainContext = {
  trainFormPrefix: "trainForm";
};

export type TrainContext = SingleTrainContext | GroupedTrainContext;

type WrapperProps = {
  Field: FC<CommonTrainInfoFormProps & CommonSubTypeProps & TrainContext>;
};

export const BatchSubfieldWrapper: FC<
  CommonTrainInfoFormProps &
    CommonSubTypeProps &
    BatchSubTypeProps &
    WrapperProps
> = ({ activeSeriesKey, groupIndex, Field, ...props }) => {
  const trainFormPrefix = `${activeSeriesKey}.${groupIndex}.trainForm` as const;
  return <Field trainFormPrefix={trainFormPrefix} {...props} />;
};

export const SingleSubfieldWrapper: FC<
  CommonTrainInfoFormProps & CommonSubTypeProps & WrapperProps
> = ({ Field, ...props }) => {
  const trainFormPrefix = `trainForm` as const;
  return <Field trainFormPrefix={trainFormPrefix} {...props} />;
};
